import {v5} from "uuid";
import {kebabCase} from "lodash";

export const namespace = "00000000-0000-0000-0000-000000000000";
export const getNormalizedHashId = (text: string): string =>
  v5(kebabCase(text), namespace);
